export const addPresentModePropToAnswerAnnotation = (payload, annotations) => {
    const answerAnnotations = annotations.filter((annotation) => annotation.type === 'answer');
    const nonAnswerAnnotations = annotations.filter((annotation) => annotation.type !== 'answer');

    const newAnswerAnnotations = answerAnnotations.map((annotation) => {
        annotation.isPresentModeActive = payload.isPresentModeActive
        return annotation;
    });

    return [...newAnswerAnnotations, ...nonAnswerAnnotations];
}
